
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _404CRJNrEieleuakf0glLLYVUBo1XdTPEp81RY6UGWZqrAMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/404.vue?macro=true";
import { default as cnytBSm7y4SV_KOO0yrQf_45fnmwgNbH_WXgJs_ca0Y9eVawMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/cny.vue?macro=true";
import { default as cartSw_45P9ljQMDvCCibTLDNEzbAVVDQ9fQ7QgegrLmicEhoMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/cart.vue?macro=true";
import { default as testZ2noF2uqFMOYbk661Av9rxI_45Bdr1W3sMzxUG92UaqiQMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/test.vue?macro=true";
import { default as abouthtlGpS3WKmlevsTjNFLwWBtUOPeSL67tjlfgvg14G_QMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/about.vue?macro=true";
import { default as indexBHKdlqqb6bLhigpFB9CFOJxL5CUVp8yXhtxoir1TXB4Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/index.vue?macro=true";
import { default as _91slug_93_45p2gxElc0yxeMHWEVVxcmt7Z9Qgrf1_45gtWHb2ZOi4A0Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/[slug].vue?macro=true";
import { default as careersJW5oJZOqMgLyp_45aR1TdLDfUZtGOMqRCW_45oyoPoZR5iwMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/careers.vue?macro=true";
import { default as join_45usbDxju9EdZWlkPYYhsPEK7IcXCgbrHjQjb6_45XLXLB7xcMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/join-us.vue?macro=true";
import { default as listingKhj7zj2b6kZjxrbgTbwZTR6_TynwzOfESc_45CEyWi_ngMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/listing.vue?macro=true";
import { default as redirectmP3qkclTNsIaq0lKSwKiZgjAqDu2jGR4r4PsfWs15_YMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/redirect.vue?macro=true";
import { default as indexAU1AZu6s1IArpyoNg1baHhDyzuMS2og70dyTdY6K69kMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/faq/index.vue?macro=true";
import { default as order_45payPL0D75G_zpqtiO62CRtez5_45yedd1B2wcoSmKt7tbjPcMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/order-pay.vue?macro=true";
import { default as indexJR9tsZg64Lxl7g528AiJIFoCjFq6BCntJhHQWkUPCv4Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/blog/index.vue?macro=true";
import { default as _91slug_93cSOaLgs0wvzHQNztb7I2YQkPU5Ufo8WbXdMtF43i0NsMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/faq/[slug].vue?macro=true";
import { default as gold_45pricedVM6Ztjlj_eHSJAcZXXepjbJqV3vDYY_45o_MPB6eXL5oMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/gold-price.vue?macro=true";
import { default as indexFuw8GDcwCr0dhhNaI87ryYOLW9fC__YzY85G3M0atCgMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/shop/index.vue?macro=true";
import { default as job_45listingvXmSXh_7NXXd4LRsXIKpxn1kfORI21ysr484i9dCpCgMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/job-listing.vue?macro=true";
import { default as _91slug_93TXmOYytpcA7ndl4fHAob_456oMaUDiNryngIJA4yWFsTAMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/jobs/[slug].vue?macro=true";
import { default as consultationmUuQGqFbmMJnnr_hZGKBvtXnOVKHbiHkFSZeds4M7v4Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/consultation.vue?macro=true";
import { default as country_45testDNpO2o897IQWiIqLlrF3DeOdS5dLrpaE14NqQJ7oaSQMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/country-test.vue?macro=true";
import { default as indexxiwy0ZJTf3vNtJmwl7OFOt_SxKc5H_XtGUIQqzBC_45XAMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/search/index.vue?macro=true";
import { default as testimonialsEGgs7yDssUaJ2FPxmU5bYd_7LQsBLPghRD6BOJKwxqIMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/testimonials.vue?macro=true";
import { default as enter_45passwordm4jB4diZ_zRh_45Cr44MjnyrmOzCDFfZ546bizNG83ndQMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/enter-password.vue?macro=true";
import { default as _91_46_46_46slug_93_GwEgylHjSNvSdI_MDNMI9pfiLrl7xPIbZQAvp_phMkMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/gift/[...slug].vue?macro=true";
import { default as _91slug_939cQKb0AxA5_mzG_6uAjV3hJytcDIqsJLyFs1AfzcYtIMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/product/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93TVvLdDmAfXOnykYcXDbmNMGmCpGkL9Oc69JmZXJ8ExUMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/shop/[...slug].vue?macro=true";
import { default as indexuC9pVKYuMyK9_45k2TP6RaNwZnKmbOEH91NR1KGqUxU8UMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/wishlist/index.vue?macro=true";
import { default as account_45detailsavIWwFYI_45wGCm2Izsi7Z5J30HcvUoBM8fJomces2x24Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/account-details.vue?macro=true";
import { default as allstar_45diamondLG28Fn9ylx69oKAuoz4ump7DM4L2zbpZEfsUy2Ja5b8Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/allstar-diamond.vue?macro=true";
import { default as _91slug_93xKWVEKg7Hlg8PTZCmyeYfVTBao3RRL_45eGVPlfdDvij0Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/blog/tag/[slug].vue?macro=true";
import { default as corporate_45giftszIPfhG8ljSSKmrbq6kRz_45frxGdnH1tYP5YNVnDZqd2QMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/corporate-gifts.vue?macro=true";
import { default as indexjfeIAsNMUuv4b659LJMo07p55YASDZd2X428JhdIRBwMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/locate-us/index.vue?macro=true";
import { default as _91slug_93L_459hoE9sX3dcBJXZwRPgwMlpbD4v2J0Wg_SsTPHorT4Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/wishlist/[slug].vue?macro=true";
import { default as customer_45reviewsyvbpQzBGbksJJjvTuXOegODKHn9MCXWdtoqZ3BLYEdYMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/customer-reviews.vue?macro=true";
import { default as _91slug_93IPfMa9mmQo8LoacuaYrM8eDNu1jdNKtBr4PnVKRufx8Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/locate-us/[slug].vue?macro=true";
import { default as indexUhB9DMWpNyURgIJV1I6n_4557z22Rp5quob_faQ_456oyQAMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/index.vue?macro=true";
import { default as _91slug_93ykieFAJYD8ZG9Y3BUVLX0iFZRrwkDmfeTrox8WtcJc0Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/[slug].vue?macro=true";
import { default as verifyy01rgf2YusXH9X06PwIacTjRtO1rr97_8aEonvt9jcgMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/verify.vue?macro=true";
import { default as indexKuNt0KrfyFFpPFoXQr8u9iNqkQ_7_45Nl0e9pN1QjBjJgMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/custom-admin/index.vue?macro=true";
import { default as _91_46_46_46slug_93OT10gbWMjYJAn31MlYQbCY_w5y2rYDOVGdPYPW5LOLcMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/gemstone/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93x61aeAD6MjQbbaKQNcW3bUy_452wiVgtaUSSbowxCrxxUMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/material/[...slug].vue?macro=true";
import { default as gold_45bar_45customiserTWNPpAIPhPCoNjAfo3vEsZY_EWZ4G8TysDi4dLR0DpQMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/gold-bar-customiser.vue?macro=true";
import { default as wishlistYmg_WsjNF8K0MGGOtVkjoyF6ZPp7agLdg_45s2sCcXTJkMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93dYdpNa__458OvwA59zouBCmm8QvwJ0b3vIlFMWqUlFBOMMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93nAh4Ar0suGeQRBOu4aC3lqDU51rlvwzGagiRCImcUTEMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/metal-color/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93q8Q7QorDLlBza8DLTK_2NvHgQEPDDqZGXQ2nck2wyb4Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/product-tag/[...slug].vue?macro=true";
import { default as vip_45star_45carat_45diamondml63TJGBYh5MrcOBNyA5IdfKKIlWqYw7GT8fAsIKZzIMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/vip-star-carat-diamond.vue?macro=true";
import { default as _91id_93cL9rMCfgShbrvYBAliTr_45_45CVKTUc8Eg8fnQ5jG84e5kMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/checkout/order-pay/[id].vue?macro=true";
import { default as lost_45passwordbKo5ZPKuj5CpiNsQgVTPObGD0WRxRQ1dFnYzNZEQYHYMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/lost-password.vue?macro=true";
import { default as _91_46_46_46slug_93XnBYEgzXIcf8v7hmq8LflyyMekDhJaSSy7UHlTipnLkMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/product-bridal/[...slug].vue?macro=true";
import { default as _91id_931kFqRQWZcjdBCl9kGc8S6iUsxoJYxwe_rQfc_45UFoD6oMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/view-order/[id].vue?macro=true";
import { default as _91_46_46_46slug_93wzrVmO4B9tmGDgyzcV_45mS8QEkxEaCq69GttChqsfeZQMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/product-category/[...slug].vue?macro=true";
import { default as allstar_45diamond_45appointmentSH9VUAbPU5tUlfwRBj4ir4EZv3PjrEit_6qk_457mKBEoMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/allstar-diamond-appointment.vue?macro=true";
import { default as engagement_45ring_45appointmentYNasgGkwgVewqFFvEF6BJyIL_XVPbcuNDfZ6pksCl5IMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/engagement-ring-appointment.vue?macro=true";
import { default as _91_46_46_46slug_93gHn6GOMCK2vzKCA3SjMjPuqUHZpOZM2xVuFKn4BbNZoMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/product-gold-type/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93mU_w7KWXA5mNFbWxVKNLw36cEIjmGAQ7E1HnQhTyz80Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/product-occasions/[...slug].vue?macro=true";
import { default as book_45si_45dian_45jin_45appointment4_lMwCVKbgzPCWXHLog4FAVUYNnexncnv22_cyqmqfAMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/book-si-dian-jin-appointment.vue?macro=true";
import { default as _91id_9302yVEfcft_45m3lGkG5fRLWO71Smb7viAMogT78Vj5DSYMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/checkout/order-received/[id].vue?macro=true";
import { default as product_45listingDuiKHhzDw0_45_1kMqdFG5BLhPzauN3W57i0D_cSrf2M8Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/custom-admin/product-listing.vue?macro=true";
import { default as _91_46_46_46slug_93JduKUlP9WM2eer63trwjeiG1zxVE1baVmu59b7e78U4Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/product-recipients/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93J7nOkoF6hwAwWr0ZaT8SeRIvUVTJ57ACOmAEfprMsZ0Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/product-price-range/[...slug].vue?macro=true";
import { default as book_45wedding_45bands_45appointmentRWDQ16dht1R_45Zvl7hd1NDUSKiomlKYGl_rHpyeue8U0Meta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/book-wedding-bands-appointment.vue?macro=true";
import { default as princess_45cut_45diamond_45appointmentWsCO3vM945lFo17eTTLqi7fQrdoVc7akFGzS1L0VBdgMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/princess-cut-diamond-appointment.vue?macro=true";
import { default as address_451Mg6KlX6q8h4_2FUA95QXp5kS8Rn31wAbNnbeDy1ze3gMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/edit-address/address-1.vue?macro=true";
import { default as address_452W4p_8dCfuWbCcfvo7ddFvNTDfYl5B9rKjoP5EJ2QQPAMeta } from "/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/edit-address/address-2.vue?macro=true";
import { default as component_45stubrBKVOrrbv_45PqgkzPUcGST5HYOBayMslCqJXpjX_45YzbkMeta } from "/Applications/stvn-git/skjmy-nuxt/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubrBKVOrrbv_45PqgkzPUcGST5HYOBayMslCqJXpjX_45Yzbk } from "/Applications/stvn-git/skjmy-nuxt/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "404___en",
    path: "/404",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/404.vue")
  },
  {
    name: "404___ms-my",
    path: "/ms-my/404",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/404.vue")
  },
  {
    name: "cny___en",
    path: "/cny",
    meta: cnytBSm7y4SV_KOO0yrQf_45fnmwgNbH_WXgJs_ca0Y9eVawMeta || {},
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/cny.vue")
  },
  {
    name: "cny___ms-my",
    path: "/ms-my/cny",
    meta: cnytBSm7y4SV_KOO0yrQf_45fnmwgNbH_WXgJs_ca0Y9eVawMeta || {},
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/cny.vue")
  },
  {
    name: "cart___en",
    path: "/cart",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/cart.vue")
  },
  {
    name: "cart___ms-my",
    path: "/ms-my/cart",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/cart.vue")
  },
  {
    name: "test___en",
    path: "/test",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/test.vue")
  },
  {
    name: "test___ms-my",
    path: "/ms-my/test",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/test.vue")
  },
  {
    name: "about___en",
    path: "/about",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/about.vue")
  },
  {
    name: "about___ms-my",
    path: "/ms-my/about",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/about.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/index.vue")
  },
  {
    name: "index___ms-my",
    path: "/ms-my",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/index.vue")
  },
  {
    name: "slug___en",
    path: "/:slug()",
    meta: {"middleware":"page-slug"},
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/[slug].vue")
  },
  {
    name: "slug___ms-my",
    path: "/ms-my/:slug()",
    meta: {"middleware":"page-slug"},
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/[slug].vue")
  },
  {
    name: "careers___en",
    path: "/careers",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/careers.vue")
  },
  {
    name: "careers___ms-my",
    path: "/ms-my/careers",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/careers.vue")
  },
  {
    name: "join-us___en",
    path: "/join-us",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/join-us.vue")
  },
  {
    name: "join-us___ms-my",
    path: "/ms-my/join-us",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/join-us.vue")
  },
  {
    name: "listing___en",
    path: "/listing",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/listing.vue")
  },
  {
    name: "listing___ms-my",
    path: "/ms-my/listing",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/listing.vue")
  },
  {
    name: "redirect___en",
    path: "/redirect",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/redirect.vue")
  },
  {
    name: "redirect___ms-my",
    path: "/ms-my/redirect",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/redirect.vue")
  },
  {
    name: "faq___en",
    path: "/faq",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/faq/index.vue")
  },
  {
    name: "faq___ms-my",
    path: "/ms-my/faq",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/faq/index.vue")
  },
  {
    name: "order-pay___en",
    path: "/order-pay",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/order-pay.vue")
  },
  {
    name: "order-pay___ms-my",
    path: "/ms-my/order-pay",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/order-pay.vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/blog/index.vue")
  },
  {
    name: "blog___ms-my",
    path: "/ms-my/blog",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/blog/index.vue")
  },
  {
    name: "faq-slug___en",
    path: "/faq/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/faq/[slug].vue")
  },
  {
    name: "faq-slug___ms-my",
    path: "/ms-my/faq/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/faq/[slug].vue")
  },
  {
    name: "gold-price___en",
    path: "/gold-price",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/gold-price.vue")
  },
  {
    name: "gold-price___ms-my",
    path: "/ms-my/gold-price",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/gold-price.vue")
  },
  {
    name: "shop___en",
    path: "/shop",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/shop/index.vue")
  },
  {
    name: "shop___ms-my",
    path: "/ms-my/shop",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/shop/index.vue")
  },
  {
    name: "job-listing___en",
    path: "/job-listing",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/job-listing.vue")
  },
  {
    name: "job-listing___ms-my",
    path: "/ms-my/job-listing",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/job-listing.vue")
  },
  {
    name: "jobs-slug___en",
    path: "/jobs/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/jobs/[slug].vue")
  },
  {
    name: "jobs-slug___ms-my",
    path: "/ms-my/jobs/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/jobs/[slug].vue")
  },
  {
    name: "consultation___en",
    path: "/consultation",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/consultation.vue")
  },
  {
    name: "consultation___ms-my",
    path: "/ms-my/consultation",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/consultation.vue")
  },
  {
    name: "country-test___en",
    path: "/country-test",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/country-test.vue")
  },
  {
    name: "country-test___ms-my",
    path: "/ms-my/country-test",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/country-test.vue")
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/search/index.vue")
  },
  {
    name: "search___ms-my",
    path: "/ms-my/search",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/search/index.vue")
  },
  {
    name: "testimonials___en",
    path: "/testimonials",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/testimonials.vue")
  },
  {
    name: "testimonials___ms-my",
    path: "/ms-my/testimonials",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/testimonials.vue")
  },
  {
    name: "enter-password___en",
    path: "/enter-password",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/enter-password.vue")
  },
  {
    name: "enter-password___ms-my",
    path: "/ms-my/enter-password",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/enter-password.vue")
  },
  {
    name: "gift-slug___en",
    path: "/gift/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/gift/[...slug].vue")
  },
  {
    name: "gift-slug___ms-my",
    path: "/ms-my/gift/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/gift/[...slug].vue")
  },
  {
    name: "product-slug___en",
    path: "/product/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product/[slug].vue")
  },
  {
    name: "product-slug___ms-my",
    path: "/ms-my/product/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product/[slug].vue")
  },
  {
    name: "shop-slug___en",
    path: "/shop/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___ms-my",
    path: "/ms-my/shop/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/shop/[...slug].vue")
  },
  {
    name: "wishlist___en",
    path: "/wishlist",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/wishlist/index.vue")
  },
  {
    name: "wishlist___ms-my",
    path: "/ms-my/wishlist",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/wishlist/index.vue")
  },
  {
    name: "account-details___en",
    path: "/account-details",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/account-details.vue")
  },
  {
    name: "account-details___ms-my",
    path: "/ms-my/account-details",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/account-details.vue")
  },
  {
    name: "allstar-diamond___en",
    path: "/allstar-diamond",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/allstar-diamond.vue")
  },
  {
    name: "allstar-diamond___ms-my",
    path: "/ms-my/allstar-diamond",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/allstar-diamond.vue")
  },
  {
    name: "blog-tag-slug___en",
    path: "/blog/tag/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/blog/tag/[slug].vue")
  },
  {
    name: "blog-tag-slug___ms-my",
    path: "/ms-my/blog/tag/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/blog/tag/[slug].vue")
  },
  {
    name: "corporate-gifts___en",
    path: "/corporate-gifts",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/corporate-gifts.vue")
  },
  {
    name: "corporate-gifts___ms-my",
    path: "/ms-my/corporate-gifts",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/corporate-gifts.vue")
  },
  {
    name: "locate-us___en",
    path: "/locate-us",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/locate-us/index.vue")
  },
  {
    name: "locate-us___ms-my",
    path: "/ms-my/locate-us",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/locate-us/index.vue")
  },
  {
    name: "wishlist-slug___en",
    path: "/wishlist/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/wishlist/[slug].vue")
  },
  {
    name: "wishlist-slug___ms-my",
    path: "/ms-my/wishlist/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/wishlist/[slug].vue")
  },
  {
    name: "customer-reviews___en",
    path: "/customer-reviews",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/customer-reviews.vue")
  },
  {
    name: "customer-reviews___ms-my",
    path: "/ms-my/customer-reviews",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/customer-reviews.vue")
  },
  {
    name: "locate-us-slug___en",
    path: "/locate-us/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/locate-us/[slug].vue")
  },
  {
    name: "locate-us-slug___ms-my",
    path: "/ms-my/locate-us/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/locate-us/[slug].vue")
  },
  {
    name: "my-account___en",
    path: "/my-account",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/index.vue")
  },
  {
    name: "my-account___ms-my",
    path: "/ms-my/my-account",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/index.vue")
  },
  {
    name: "my-account-slug___en",
    path: "/my-account/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/[slug].vue")
  },
  {
    name: "my-account-slug___ms-my",
    path: "/ms-my/my-account/:slug()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/[slug].vue")
  },
  {
    name: "my-account-verify___en",
    path: "/my-account/verify",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/verify.vue")
  },
  {
    name: "my-account-verify___ms-my",
    path: "/ms-my/my-account/verify",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/verify.vue")
  },
  {
    name: "custom-admin___en",
    path: "/custom-admin",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/custom-admin/index.vue")
  },
  {
    name: "custom-admin___ms-my",
    path: "/ms-my/custom-admin",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/custom-admin/index.vue")
  },
  {
    name: "gemstone-slug___en",
    path: "/gemstone/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/gemstone/[...slug].vue")
  },
  {
    name: "gemstone-slug___ms-my",
    path: "/ms-my/gemstone/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/gemstone/[...slug].vue")
  },
  {
    name: "material-slug___en",
    path: "/material/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/material/[...slug].vue")
  },
  {
    name: "material-slug___ms-my",
    path: "/ms-my/material/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/material/[...slug].vue")
  },
  {
    name: "gold-bar-customiser___en",
    path: "/gold-bar-customiser",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/gold-bar-customiser.vue")
  },
  {
    name: "gold-bar-customiser___ms-my",
    path: "/ms-my/gold-bar-customiser",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/gold-bar-customiser.vue")
  },
  {
    name: "my-account-wishlist___en",
    path: "/my-account/wishlist",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/wishlist.vue")
  },
  {
    name: "my-account-wishlist___ms-my",
    path: "/ms-my/my-account/wishlist",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/wishlist.vue")
  },
  {
    name: "collection-slug___en",
    path: "/collection/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/collection/[...slug].vue")
  },
  {
    name: "collection-slug___ms-my",
    path: "/ms-my/collection/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/collection/[...slug].vue")
  },
  {
    name: "metal-color-slug___en",
    path: "/metal-color/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/metal-color/[...slug].vue")
  },
  {
    name: "metal-color-slug___ms-my",
    path: "/ms-my/metal-color/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/metal-color/[...slug].vue")
  },
  {
    name: "product-tag-slug___en",
    path: "/product-tag/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-tag/[...slug].vue")
  },
  {
    name: "product-tag-slug___ms-my",
    path: "/ms-my/product-tag/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-tag/[...slug].vue")
  },
  {
    name: "vip-star-carat-diamond___en",
    path: "/vip-star-carat-diamond",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/vip-star-carat-diamond.vue")
  },
  {
    name: "vip-star-carat-diamond___ms-my",
    path: "/ms-my/vip-star-carat-diamond",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/vip-star-carat-diamond.vue")
  },
  {
    name: "checkout-order-pay-id___en",
    path: "/checkout/order-pay/:id()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/checkout/order-pay/[id].vue")
  },
  {
    name: "checkout-order-pay-id___ms-my",
    path: "/ms-my/checkout/order-pay/:id()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/checkout/order-pay/[id].vue")
  },
  {
    name: "my-account-lost-password___en",
    path: "/my-account/lost-password",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/lost-password.vue")
  },
  {
    name: "my-account-lost-password___ms-my",
    path: "/ms-my/my-account/lost-password",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/lost-password.vue")
  },
  {
    name: "product-bridal-slug___en",
    path: "/product-bridal/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-bridal/[...slug].vue")
  },
  {
    name: "product-bridal-slug___ms-my",
    path: "/ms-my/product-bridal/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-bridal/[...slug].vue")
  },
  {
    name: "my-account-view-order-id___en",
    path: "/my-account/view-order/:id()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/view-order/[id].vue")
  },
  {
    name: "my-account-view-order-id___ms-my",
    path: "/ms-my/my-account/view-order/:id()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/view-order/[id].vue")
  },
  {
    name: "product-category-slug___en",
    path: "/product-category/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-category/[...slug].vue")
  },
  {
    name: "product-category-slug___ms-my",
    path: "/ms-my/product-category/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-category/[...slug].vue")
  },
  {
    name: "allstar-diamond-appointment___en",
    path: "/allstar-diamond-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/allstar-diamond-appointment.vue")
  },
  {
    name: "allstar-diamond-appointment___ms-my",
    path: "/ms-my/allstar-diamond-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/allstar-diamond-appointment.vue")
  },
  {
    name: "engagement-ring-appointment___en",
    path: "/engagement-ring-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/engagement-ring-appointment.vue")
  },
  {
    name: "engagement-ring-appointment___ms-my",
    path: "/ms-my/engagement-ring-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/engagement-ring-appointment.vue")
  },
  {
    name: "product-gold-type-slug___en",
    path: "/product-gold-type/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-gold-type/[...slug].vue")
  },
  {
    name: "product-gold-type-slug___ms-my",
    path: "/ms-my/product-gold-type/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-gold-type/[...slug].vue")
  },
  {
    name: "product-occasions-slug___en",
    path: "/product-occasions/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-occasions/[...slug].vue")
  },
  {
    name: "product-occasions-slug___ms-my",
    path: "/ms-my/product-occasions/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-occasions/[...slug].vue")
  },
  {
    name: "book-si-dian-jin-appointment___en",
    path: "/book-si-dian-jin-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/book-si-dian-jin-appointment.vue")
  },
  {
    name: "book-si-dian-jin-appointment___ms-my",
    path: "/ms-my/book-si-dian-jin-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/book-si-dian-jin-appointment.vue")
  },
  {
    name: "checkout-order-received-id___en",
    path: "/checkout/order-received/:id()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/checkout/order-received/[id].vue")
  },
  {
    name: "checkout-order-received-id___ms-my",
    path: "/ms-my/checkout/order-received/:id()",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/checkout/order-received/[id].vue")
  },
  {
    name: "custom-admin-product-listing___en",
    path: "/custom-admin/product-listing",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/custom-admin/product-listing.vue")
  },
  {
    name: "custom-admin-product-listing___ms-my",
    path: "/ms-my/custom-admin/product-listing",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/custom-admin/product-listing.vue")
  },
  {
    name: "product-recipients-slug___en",
    path: "/product-recipients/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-recipients/[...slug].vue")
  },
  {
    name: "product-recipients-slug___ms-my",
    path: "/ms-my/product-recipients/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-recipients/[...slug].vue")
  },
  {
    name: "product-price-range-slug___en",
    path: "/product-price-range/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-price-range/[...slug].vue")
  },
  {
    name: "product-price-range-slug___ms-my",
    path: "/ms-my/product-price-range/:slug(.*)*",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/product-price-range/[...slug].vue")
  },
  {
    name: "book-wedding-bands-appointment___en",
    path: "/book-wedding-bands-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/book-wedding-bands-appointment.vue")
  },
  {
    name: "book-wedding-bands-appointment___ms-my",
    path: "/ms-my/book-wedding-bands-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/book-wedding-bands-appointment.vue")
  },
  {
    name: "princess-cut-diamond-appointment___en",
    path: "/princess-cut-diamond-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/princess-cut-diamond-appointment.vue")
  },
  {
    name: "princess-cut-diamond-appointment___ms-my",
    path: "/ms-my/princess-cut-diamond-appointment",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/princess-cut-diamond-appointment.vue")
  },
  {
    name: "my-account-edit-address-address-1___en",
    path: "/my-account/edit-address/address-1",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/edit-address/address-1.vue")
  },
  {
    name: "my-account-edit-address-address-1___ms-my",
    path: "/ms-my/my-account/edit-address/address-1",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/edit-address/address-1.vue")
  },
  {
    name: "my-account-edit-address-address-2___en",
    path: "/my-account/edit-address/address-2",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/edit-address/address-2.vue")
  },
  {
    name: "my-account-edit-address-address-2___ms-my",
    path: "/ms-my/my-account/edit-address/address-2",
    component: () => import("/Applications/stvn-git/skjmy-nuxt/src/pages/my-account/edit-address/address-2.vue")
  },
  {
    name: component_45stubrBKVOrrbv_45PqgkzPUcGST5HYOBayMslCqJXpjX_45YzbkMeta?.name,
    path: "/__nuxt_error/",
    component: component_45stubrBKVOrrbv_45PqgkzPUcGST5HYOBayMslCqJXpjX_45Yzbk
  }
]